import styled, { css } from 'styled-components';

export const FilesListContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
`;

export const FileImage = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  max-height: 179px;
  height: 179px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.background.tertiary};

  img {
    width: 100%;
  }

  object {
    pointer-events: none;
    width: calc(100% + 20px);
    height: 100%;
  }

  svg {
    color: ${({ theme }) => theme.colors.brand.primary};
  }
`;

export const FileItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 243px;
  width: 100%;
  transition: background-color 0.2s ease;
  border-radius: 8px;
  gap: 24px;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    ${FileImage} {
      //box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
  }
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
`;

export const FileName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.element.primary};
  margin-bottom: 2px;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;

  & > span {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const FileDetail = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.element.secondary};
  display: flex;
  align-items: center;
  font-weight: 400;
  white-space: nowrap;
`;

export const FileAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    color: ${({ theme }) => theme.colors.brand.primary};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}
`;

export const EmptyList = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colors.neutral.primary};
  font-size: 14px;
  width: 100%;
`;

export const BottomInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const ActionsRow = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
`;
